import {Link} from "react-router-dom";
import VideoSource from "./VideoSource";

const VideoCard = ({props}) => {
    const {name, btnText, path, url} = props;
    return (
        <Link to={url === "" ? "/error" : url}
              className={`${url === "" ? "disabled-link" : ""} video__card flex end relative hover__card block`}
              style={{gridArea: name ? name : ""}}
        >
            <VideoSource path={path} name={name} className="about__video" text={btnText} width={[320,480,720]}/>
        </Link>
    )
}
export default VideoCard